import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const paper = css`
  min-inline-size: 360px;
`
export const body = css`
  overflow: hidden;
  margin-block-end: ${spacing(1.5)} !important;
`
export const title = css`
  max-inline-size: 296px;
`
